export class StaticToast {
  showToast = true;

  onToastClose(): void {
    this.showToast = false;
  }
}
